import React, { useState, useEffect } from "react";

function InlineNotification(props) {
	const [isActive, setIsActive] = useState(props.isActive);
	let display = "none";
	
	isActive ? (display = "block") : (display = "none");
	const style = {
		error: {
			display: display,
			background: "none",
			color: "red",
			fontSize: "0.8rem",
			margin: "5px",
			padding: "0"
		},

		warning: {
			display: display,
			background: "none",
			color: "orange",
			fontSize: "0.8rem",
			margin: "5px",
			padding: "0"
		},

		success: {
			display: display,
			background: "none",
			color: "green",
			fontSize: "0.8rem",
			margin: "5px",
			padding: "0"
		},
	};
	return (
		<div>
			<p style={style.error}> {props.message} </p>
		</div>
	);
}

export default InlineNotification;
